import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonIcon, IonText } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { toggleSharp, colorWandSharp, backspaceSharp } from 'ionicons/icons';
import { PuzzleHelpDialogInjectableInterface } from '../../shared-module/puzzle-help-dialog/puzzle-help-dialog-injectable.interface';
import { HelperFunctionsService } from '../../shared-module/helpers/helper-functions.service';
import { PuzzleFrameworkService } from '../../puzzle-framework-module/puzzle-framework.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-app-sudoku-help',
  templateUrl: './sudoku-help.component.html',
  styleUrls: ['./sudoku-help.component.scss'],
  standalone: true,
  imports: [CommonModule, IonIcon, IonText, TranslateModule],
})
export class SudokuHelpComponent implements PuzzleHelpDialogInjectableInterface {
  data: any;
  mobile: boolean;
  translationKey: string;

  constructor(private helperFunctionService: HelperFunctionsService, private framework: PuzzleFrameworkService) {
    addIcons({
      toggleSharp,
      colorWandSharp,
      backspaceSharp,
    });
    this.mobile = helperFunctionService.isMobileDevice();
    this.translationKey = this.framework.getTranslationKey();
  }

  setData(data: any): void {
    this.data = data;
  }
}
